import { createNamespace } from "Common/namespaceUtils/namespaceRedux";
import { NAMESPACE as PARENT_NAMESPACE } from "../constants";
export const NAMESPACE = "workSpaceEditor";
export const FULL_NAMESPACE = createNamespace(PARENT_NAMESPACE, NAMESPACE);
export { PARENT_NAMESPACE as PAGE_NAMESPACE };
export const NEW_WORKSPACE = {
    Id: 0,
    Name: "",
    Created: 0,
    Description: ""
};
export const requiredFields = ["Name"];
